import React from 'react';
import { Modal, Row, Col, Input, message } from 'antd';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';

const TextArea = Input.TextArea;

class InvRemark extends React.Component {
    state = {
        visible: false,
        loading: false,
        remark: ""
    }

    show = investigationId => {
        this.setState({
            investigationId,
            visible: true,
            remark: "",
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (e) => {
        this.setState({
            remark: e.target.value
        });
    }

    handleSubmit = () => {
        const { investigationId, remark } = this.state;
        if (!remark) {
            message.warning("备注内容不能为空");
            return;
        }
        this.setState({ loading: true });
        const options = {
            url: `${API_URL.sumtotal.addInvestigationFinishRemark}`,
            data: {
                remark,
                investigationId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    visible: false,
                    loading: false,
                    remark: "",
                }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    render() {
        const { visible, loading, remark } = this.state;
        return (
            <Modal
                title="添加备注"
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="500px"
                loading={loading}
            >
                <Row>
                    <Col span={5}>备注：</Col>
                    <Col span={18}>
                        <TextArea placeholder='请填写项目备注' value={remark} rows={8} onChange={this.handleChange} />
                    </Col>
                </Row>
            </Modal>
        );
    }
}

export default InvRemark;


// WEBPACK FOOTER //
// ./src/components/sumTotal/projectPercent/InvRemark.js